var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-icon"},[_c('img',{staticClass:"icon",attrs:{"src":_vm.icon,"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.$t(_vm.text)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }